<template>
  <v-dialog :model-value="modelValue" max-width="780" @update:model-value="$emit('update:modelValue', $event)">
    <v-card color="surface" rounded="lg" class="pa-6">
      <div class="text-center mb-6">
        <h2 class="text-h5 font-weight-bold mb-2">What would you like to set up?</h2>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Pick the closest fit — then just describe it in Chat and I’ll build the rest.
        </p>
      </div>

      <v-row dense>
        <v-col v-for="k in kinds" :key="k.key" cols="12" sm="4">
          <v-card
            color="background"
            variant="elevated"
            elevation="4"
            height="100%"
            class="pa-5 d-flex flex-column ga-3 kind-card"
            @click="$emit('pick', k.key)"
          >
            <div class="d-flex align-center justify-space-between">
              <v-avatar color="primary" variant="tonal" rounded="lg" size="46">
                <v-icon :icon="k.icon" />
              </v-avatar>
              <v-chip v-if="k.beta" size="x-small" variant="tonal" color="grey">Beta</v-chip>
            </div>
            <span class="text-subtitle-1 font-weight-bold">{{ k.title }}</span>
            <span class="text-body-2 text-medium-emphasis flex-grow-1">{{ k.desc }}</span>
            <span class="text-caption text-disabled text-uppercase">{{ k.tech }}</span>
          </v-card>
        </v-col>
      </v-row>

      <p class="text-center text-caption text-disabled mt-6 mb-0">
        Not sure? Pick anything — you can change how it works at any point, or just tell me in Chat.
      </p>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { AUTO_KINDS } from '@/data/automations'
import type { AutoKind } from '@/data/automations'

@Options({
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ['update:modelValue', 'pick']
})
export default class AutomationKindDialog extends Vue {
  modelValue!: boolean
  kinds: AutoKind[] = AUTO_KINDS
}
</script>

<style scoped lang="scss">
.kind-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  cursor: pointer;
  transition: border-color 0.16s, transform 0.16s;

  &:hover {
    border-color: rgb(var(--v-theme-primary));
    transform: translateY(-2px);
  }
}
</style>
